<div class="min-h-screen flex w-full background-jakarta relative overflow-hidden">
    <!-- Loading Indicator saat check authentication -->
    <div *ngIf="isCheckingAuth" class="absolute inset-0 flex items-center justify-center bg-white bg-opacity-30 z-20">
        <div class="bg-white w-full max-w-sm rounded-xl shadow-xl p-6">
            <div class="flex flex-col items-center justify-center py-8">
                <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mb-4"></div>
                <p class="text-gray-600 text-sm">Checking authentication...</p>
            </div>
        </div>
    </div>

    <!-- Left Side -->
    <div class="hidden lg:flex w-1/2 bg-primary-green min-h-screen items-center justify-center relative z-10">
        <img src="assets/images/pages/login/client-area.png" alt="client-area" class="max-h-[60vh] object-contain drop-shadow-lg" />
    </div>

    <!-- Right Side -->
    <div class="w-full lg:w-1/2 flex items-center justify-center h-screen overflow-y-auto p-4 lg:p-0">
        <div *ngIf="!isCheckingAuth" class="bg-white w-full max-w-sm rounded-xl shadow-lg p-6">
            <h1 class="text-center text-4xl font-semibold text-gray-800 mb-6">
                SIGN IN
            </h1>

            <!-- Error Message -->
            <div *ngIf="errorMessage" class="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 text-sm rounded-lg">
                {{ errorMessage }}
            </div>

            <form (ngSubmit)="onSignIn()" class="space-y-4">
                <div>
                    <label for="email" class="block text-sm text-gray-600 mb-1 font-semibold">Email</label>
                    <div
                        class="flex items-center w-full px-3 border border-gray-300 rounded-lg focus:border-indigo-500 focus:ring-indigo-500 outline-none text-sm py-3 gap-2 focus-within:ring-2 focus-within:ring-indigo-500">
                        <img src="assets/visidea/icon/team.png" alt="" class="w-5 h-5" />
                        <input id="email" type="email" [(ngModel)]="credentials.email" name="email"
                            class="w-full border-none outline-none text-sm" placeholder="Enter your email"
                            [disabled]="isLoading" required autocomplete="email" autofocus/>
                    </div>
                </div>

                <div>
                    <label for="password" class="block text-sm text-gray-600 mb-1 font-semibold">Password</label>

                    <div
                        class="flex items-center w-full px-3 border border-gray-300 rounded-lg focus-within:ring-2 focus-within:ring-indigo-500 text-sm py-3 gap-2">
                        <img (click)="showPassword = !showPassword" [src]="
                                showPassword
                                    ? 'assets/visidea/icon/eye-off.svg'
                                    : 'assets/visidea/icon/eye.svg'
                            " class="w-5 h-5 cursor-pointer" />

                        <input id="password" [type]="showPassword ? 'text' : 'password'"
                            [(ngModel)]="credentials.password" name="password"
                            class="w-full border-none outline-none text-sm" placeholder="Enter your password"
                            [disabled]="isLoading" required />
                    </div>
                </div>

                <button type="submit" [disabled]="isLoading"
                    class="w-full py-3 bg-primary-green text-white text-lg font-semibold rounded-lg hover:bg-primary-green-hover transition disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center">
                    <span *ngIf="!isLoading">Sign In</span>
                    <span *ngIf="isLoading" class="flex items-center">
                        <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg"
                            fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4">
                            </circle>
                            <path class="opacity-75" fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                            </path>
                        </svg>
                        Signing in...
                    </span>
                </button>
            </form>

            <p class="text-gray-500 text-sm text-center mt-4">
                © 2026

                <span class="font-semibold">AWH </span>

                . Powered by
                <span class="font-semibold">PT. AWH Inti Nusantara. </span>
            </p>

            <!-- <p class="text-center text-sm text-gray-500 mt-4">
                Don't have an account?
                <a
                    href="#"
                    class="text-link-register font-medium hover:underline"
                    >Register</a
                >
            </p> -->
        </div>
    </div>

    <!-- Login Form -->
</div>
